import * as CoreUiReducer from './reducer';
import * as CoreUiSelectors from './selectors';

export {
  CoreUiReducer,
  CoreUiSelectors
};
